import { Card, Grid, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import {
  callAPI,
  clearRequest,
  getLocalValue,
  LoacalVariables,
  Method
} from "../../commonFunctions/CommonFunctions";
import {
  HeaderList,
  IHeaderListActions
} from "../../Components/Header/HeaderList";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import { WSIcons } from "../../commonFunctions/iIcons";

export const Rider: React.FC<any> = React.memo((props) => {
  const { control, handleSubmit, setValue } = useForm();
  const navigate = useNavigate();

  const params = useParams();
  const id = params?.id;
  const { showMessage } = useSnackbar();

  useEffect(() => {
    /**
     * Edit Function
     * @param id
     *
     */
    async function getServiceById(id: any) {
      try {
        const response: any = await callAPI("riders", Method.GET, null, id);
        

        if (response) {
          setValue("fullName", response.fullName);
          setValue("phoneNumber", response.phoneNumber);
          setValue("email", response.email);
          setValue("address", response.address);
          setValue("vehicleNumber", response.vehicleNumber);
        }
      } catch (error) {
        console.error("failed to retrieve data", error);
        showMessage("Something went wrong. Please try again.", "error");
      }
    }
    if (id) {
      getServiceById(id);
    }
  }, [id, setValue]);

  const handleCancelClick = () => {
    navigate("/rider/list");
  };

  /**
   * Method for Add/Update the data
   * @param data
   */

  const handleData = async (data: any) => {
    
    try {
      let request = {
        franchiseId: getLocalValue(LoacalVariables.FranchiseId),
        fullName: data.fullName,
        phoneNumber: data.phoneNumber,
        email: data.email,
        address: data.address,
        vehicleNumber: data.vehicleNumber,
        status: "Active"
      };
      

      const newRequest = clearRequest(request);

      const endpoint = id ? `riders/${id}` : "riders";

      const method = id ? Method.PUT : Method.POST;

      const response: any = await callAPI(endpoint, method, newRequest);

      

      
      if (response && id) {
        showMessage(response, "success");
        navigate("/rider/list");
      }else {
        showMessage(response?.message, "success");
        navigate("/rider/list");
      }
    } catch (e: any) {
      showMessage(e.message, "error");
    }
  };

  const actions: IHeaderListActions[] = [
    {
      type: "icon",
      text: "Cancel",
      size: "small",
      onClick: handleCancelClick,
      variant: "outlined",
      color: "error",
      icon: <WSIcons.CancelIcon />
    },
    {
      type: "icon",
      text: "Save",
      size: "small",
      buttonType: "submit",
      variant: "outlined",
      color: "success",
      icon: <WSIcons.SaveIcon />
    }
  ];

  return (
    <>
      <form onSubmit={handleSubmit(handleData)}>
        <HeaderList title="Add Rider" type="card" actions={actions} />
        <Card sx={{ padding: 2, borderRadius: 2 }}>
          <Grid
            item
            container
            spacing={1}
            justifyContent={"start"}
            sx={{
              marginTop: 0,
              marginLeft: 0,
              width: "100%",
              backgroundColor: "#7D79C2",
              borderTopLeftRadius: 5,
              borderTopRightRadius: 5
            }}
          >
            <Grid
              alignContent={"center"}
              style={{ paddingLeft: 20, paddingTop: 0, height: "3rem" }}
              item
              sm={4}
              className="ws-data-grid-lightviolet-title"
            >
              <Typography
                variant="h6"
                id="tableTitle"
                sx={{ fontSize: "1rem" }}
              >
                Rider Information
              </Typography>
            </Grid>
          </Grid>
          <Grid
            sx={{
              padding: 3,
              backgroundColor: "#fff",
              borderBottomLeftRadius: 5,
              borderBottomRightRadius: 5,
              border: "1px solid lightgrey"
              // marginTop: 3,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <WSTextField
                  label={"Rider FullName"}
                  rules={{ required: "Rider Full Name is required" }}
                  id="fullName"
                  name="fullName"
                  control={control}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <WSTextField
                  label={"Email Address"}
                  rules={{ required: "Email Address is required" }}
                  id="email"
                  name="email"
                  control={control}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <WSTextField
                  label={"Rider Address"}
                  rules={{ required: "Rider Address is required" }}
                  id="address"
                  name="address"
                  control={control}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <WSTextField
                  label={"Phone Number"}
                  rules={{ required: "Phone Number is required" }}
                  id="phoneNumber"
                  name="phoneNumber"
                  control={control}
                  type={TextType.Number}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <WSTextField
                  label={"Vehicle Number"}
                  id="vehicleNumber"
                  name="vehicleNumber"
                  control={control}
                  rules={{
                    required: "Vehicle Number is required",
                    pattern: {
                      value:
                        /^[A-Z]{2}[-\s]?[0-9]{2}[-\s]?[A-Z]{0,2}[-\s]?[0-9]{4}$/,
                      message: "Enter a valid Indian vehicle number"
                    }
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </form>
    </>
  );
});
